/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	// パラメータチェック
	let urlParam = location.search.substring(1);
	let paramArray = [];
	if(urlParam) {
		let param = urlParam.split('&');
		for(let i = 0; i < param.length; i++) {
			let paramItem = param[i].split('=');
			paramArray[paramItem[0]] = paramItem[1];
		}
	}
	// キーワードノーマライズ
	const keywordNormalize = () => {
		let kewordVal = $('.js-keyword').val();
		let kewordVal2 = kewordVal.normalize("NFKC");
		$('.js-keyword').val(kewordVal2);
	}
	const texhnologyDocumentSearch = () => {
		if($('.js-division-pulldown').length) {
			const divisionSelect = $('.js-division-pulldown');
			const getJSONdivision = () => {
				return $.getJSON(`/ajax/technology/division.json`);
			};
			divisionSelect.addClass('is-hidden');
			getJSONdivision().then((data) => {
				// console.log(data.rt_bn_division_list,'data');
				for(let i = 0; i < data.rt_bn_division_list.length; i++) {
					if(paramArray.p_division === data.rt_bn_division_list[i]._key) {
						divisionSelect.append($('<option>').html(data.rt_bn_division_list[i].cf_sd_name).val(data.rt_bn_division_list[i]._key).prop('selected', true));
					} else {
						divisionSelect.append($('<option>').html(data.rt_bn_division_list[i].cf_sd_name).val(data.rt_bn_division_list[i]._key));
					}
					
				}
				divisionSelect.removeClass('is-hidden');
			});
			divisionSelect.change(function(){
				keywordNormalize();
				$('.js-field-pulldown').val('');
				$(this).parents('form').submit();
			});
		}
		if($('.js-field-pulldown').length) {
			const fieldSelect = $('.js-field-pulldown');
			const getJSONfield = (_division) => {
				return $.getJSON(`/ajax/technology/${_division}/division.json`);
			};
			fieldSelect.addClass('is-hidden');
			if(paramArray.p_division) {
				getJSONfield(paramArray.p_division).then((data) => {
					// console.log(data,'data');
					for(let i = 0; i < data.rt_bn_field_list.length; i++) {
						if(paramArray.p_field === data.rt_bn_field_list[i]._key) {
							fieldSelect.append($('<option>').html(data.rt_bn_field_list[i].cf_sf_name).val(data.rt_bn_field_list[i]._key).prop('selected', true));
						} else {
							fieldSelect.append($('<option>').html(data.rt_bn_field_list[i].cf_sf_name).val(data.rt_bn_field_list[i]._key));
						}
					}
					fieldSelect.removeClass('is-hidden');
				});
			} else {
				// fieldSelect.css('color', '#ddd');
			}
			fieldSelect.change(function(){
				keywordNormalize();
				$(this).parents('form').submit();
			});
		}
		if($('.js-keyword').length) {
			if(paramArray.p_keyword) {
				$('.js-keyword').val(decodeURI(paramArray.p_keyword));
			}
			$('.js-keyword').keypress(function(e){
				if(e.keyCode == 13) {
					keywordNormalize();
					$(this).parents('form').submit();
					return false;
				}
			});
		}
	};
	const texhnologyDetail = () => {
		if($('.js-technology-detail').length) {
			if(!($('.rt_cf_n_service_field_id').length)) {
				$('.js-technology-detail').addClass('di_none');
			} else {
				const getJSONtexhnologyDetail = (_field) => {
					return $.getJSON(`/ajax/technology/detail/related_technology/${$('.rt_cf_n_key').text()}.json${_field}`);
				};
				let jsonParmBox = '';
				let HTML = '';
				for(let i = 0; i < $('.rt_cf_n_service_field_id').length; i++) {
					$('.rt_cf_n_service_field_id').eq(i).text();
					jsonParmBox += ('&p_field='+$('.rt_cf_n_service_field_id').eq(i).text());
				}
				let jsonParm = '?'+(jsonParmBox.slice(1));
				// console.log(jsonParm,'jsonParm');
				getJSONtexhnologyDetail(jsonParm).then((data) => {
					HTML = '';
					// console.log(data,'data');
					for(let l = 0; l < data.rt_bn_related_technology_info.length; l++) {
						let news = '';
						if(!(data.rt_bn_related_technology_info[l].rt_cf_n_new.content) == 'false') {
							news = '<span class="mod-newIcon"><span>NEW</span></span>';
						}
						let img = '';
						if(data.rt_bn_related_technology_info[l].rt_cf_n_thum_img) {
							img = '<img src="'+data.rt_bn_related_technology_info[l].rt_cf_n_thum_img['data-src'] +'" class="width-u-100" alt="'+data.rt_bn_related_technology_info[l].cf_n_title+'">';
						}
						HTML += '<li class="pure-u-1-4 pure-u-md-1-2 space-u-40-child"><a href="'+data.rt_bn_related_technology_info[l].rt_cf_n_href_technology.href+'" class="di_block">'+
						'<figure class="mod-newIconWrap">'+
						img +
						news +
						'</figure>'+
						'<h3 class="mod-head04 _borderNone mt20">'+data.rt_bn_related_technology_info[l].cf_n_title+'</h3>'+
						'<ul class="mod-labelWrap pt30">';
						for(let m = 0; m < data.rt_bn_related_technology_info[l].cf_n_service_field.length; m++) {
							HTML += '<li><span class="mod-label '+data.rt_bn_related_technology_info[l].cf_n_service_field[m].cf_sf_sd_id+'">'+data.rt_bn_related_technology_info[l].cf_n_service_field[m].cf_sf_name+'</span></li>';
						}
						HTML += '</ul></a></li>';
					}
					$('.js-technology-detail-list').append(HTML);
				});
			}
		}
	};
	texhnologyDocumentSearch();
	texhnologyDetail();
})(window.jQuery, window.FUNCTIONS);